import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getBiopsyListSlice = createAsyncThunk(
  "biopsyTracking/getBiopsyTrackList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/biopsyTracking/getBiopsyTrackList", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getBiopsyByIdSlice = createAsyncThunk(
  "biopsyTracking/getBiopsyTrackById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/biopsyTracking/getBiopsyTrackById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createBiopsySlice = createAsyncThunk(
  "biopsyTracking/createBiopsyTrack",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/biopsyTracking/createBiopsyTrack", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateBiopsySlice = createAsyncThunk(
  "biopsyTracking/updateBiopsyTrack",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/biopsyTracking/updateBiopsyTrack", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteBiopsySlice = createAsyncThunk(
  "biopsyTracking/deleteBiopsyTrack",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/biopsyTracking/deleteBiopsyTrack", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  biopsy: [],
  biopsyById: [],
  error: null,
  isLoading: false,
  createBiopsySuccessMessage: null,
  createBiopsyErrorMessage: null,
  updateBiopsySuccessMessage: null,
  updateBiopsyErrorMessage: null,
  deleteBiopsySuccessMessage: null,
  deleteBiopsyErrorMessage: null,
  searchMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const biopsySlice = createSlice({
  name: "biopsy",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createBiopsySuccessMessage = null;
      state.createBiopsyErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateBiopsySuccessMessage = null;
      state.updateBiopsyErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteBiopsySuccessMessage = null;
      state.deleteBiopsyErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBiopsyListSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBiopsyListSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.biopsy = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage = action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.biopsy = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })

      .addCase(getBiopsyListSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getBiopsyByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBiopsyByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.biopsyById = action.payload.result.list;
      })

      .addCase(getBiopsyByIdSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createBiopsySlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBiopsySlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createBiopsyErrorMessage = action.payload.result.message;
        } else {
          state.createBiopsySuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createBiopsySlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateBiopsySlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBiopsySlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateBiopsySuccessMessage = action.payload.result.message;
        } else {
          state.updateBiopsyErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateBiopsySlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteBiopsySlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteBiopsySlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteBiopsySuccessMessage = action.payload.result.message;
        } else {
          state.deleteBiopsyErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteBiopsySlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } =
  biopsySlice.actions;
export default biopsySlice.reducer;
